import * as t from "./actionTypes";

const initialState = {
	stream: {
		subscription: null
	},
	usersById: {},
	lastUpdated: null
};

const toUsersById = (users = []) => {
	const map = {};
	users.forEach(u => {
		if (u?.id) map[u.id] = u;
	});
	return map;
};

export default function onlineUsers(state = initialState, action) {
	switch (action.type) {
		case t.ONLINE_USERS_STREAM_STARTED:
			return {
				...state,
				stream: { subscription: action.payload?.subscription || null }
			};

		case t.ONLINE_USERS_STREAM_STOPPED:
			return { ...initialState };

		case t.ONLINE_USERS_INITIAL:
		case t.ONLINE_USERS_UPDATE: {
			const users = action.payload?.users || [];
			return {
				...state,
				usersById: toUsersById(users),
				lastUpdated: new Date().toISOString()
			};
		}

		case t.ONLINE_USERS_ADD_OR_UPDATE: {
			const incoming = action.payload?.users || [];
			if (!incoming.length) return state;

			const next = { ...state.usersById };
			incoming.forEach(u => {
				if (u?.id) next[u.id] = u;
			});

			return {
				...state,
				usersById: next,
				lastUpdated: new Date().toISOString()
			};
		}

		case t.ONLINE_USERS_REMOVE: {
			const userIds = action.payload?.userIds || [];
			if (!userIds.length) return state;

			const next = { ...state.usersById };
			userIds.forEach(id => delete next[id]);

			return {
				...state,
				usersById: next,
				lastUpdated: new Date().toISOString()
			};
		}

		default:
			return state;
	}
}
